const ReimbursementReasons = [
  {
    _id: process.env.REACT_APP_DINING_BENEFIT_ID,
    reason: 'Dining Benefit',
  },
  {
    _id: process.env.REACT_APP_EQUIPMENT_ALLOWANCE_ID,
    reason: 'Equipment Allowance',
  },
  {
    _id: process.env.REACT_APP_FUEL_REIMBURSEMENT_ID,
    reason: 'Fuel Reimbursement',
  },
];

export default ReimbursementReasons;